export const getPractitionerSignatureSource = (signatureURL) =>
    signatureURL?.presignedUrl ||
    signatureURL?.base64Data ||
    signatureURL?.url ||
    null;

export const getProfilePhotoSource = (photo) =>
    photo?.presignedUrl ||
    photo?.base64Data ||
    photo?.url ||
    null;
